export default __webpack_public_path__ + "static/media/csm.b91c256e.mp4";